export const canEditReview = (role: string, hasFullVisiblity: boolean): boolean => {
  if (hasFullVisiblity) {
    return true
  } else {
    const roles = JSON.parse(role.replace(/=>/g, ':'))
    return roles.author || roles.supervisor
  }
}
